import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
  RefreshBox,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import { wsGetPDFOrdenEstudio } from "_+_Portal/_-_Autocheckin/context/action/ordenesDigitales";
import { base64toBlob } from "global/utils/base64toBlob";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import camelize from "global/utils/camelize";
import {
  setAltaOrdenDigitalEstudio,
  setFlgVolverOrdenDigitalEstudio,
  setMedicoSolicitante,
  wsGetGrupoByIdOrden,
  wsGetOrdenDigitalEstudio,
} from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import { useHistory } from "react-router";
import { FaSyncAlt } from "react-icons/fa";
import {
  setAltaTurnoOrdenDigital,
  wsGetLabOrdenDigital,
} from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import { wsGetPDFOrdenDigital } from "_+_Portal/context/Actions/pdfOrdenDigital/pdfOrdenDigital";
import fechaTurnoFormat from "global/utils/fechaTurnoFormat";
import { wsGetLaboCentros } from "_+_Portal/context/Actions/laboGrupo/laboGrupo";
import {
  setBuscarTurnoLabo,
  wsGetLaboTurnos,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import { showModal, hideModal } from "_+_Portal/context/Actions/modal/modal";
import ScrollArrows from "_+_Portal/components/Genericos/ScrollArrows/ScrollArrows";

const OrdenesDigitales = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const {
    ordenDigitalDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    labOrdenDigitalDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    modalDispatch,
  } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const history = useHistory();
  let getOrdenes = sessionStorage.getItem("getOrdenes");
  const centroQR = sessionStorage.getItem("centroID");
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [ordenesList, setOrdenesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = (item) => {
    // Muestra la orden: en mobile abre nueva pestaña; en tablet/desktop, modal PDF
    setLoadingPDF(true);
    const isMobile = window.innerWidth < 768;

    // Prioridad: si viene una URL (linkPdfRcta), abrirla directamente
    // - En mobile abre nueva pestaña
    // - En desktop/tablet abre visor modal con PDFViewer
    if (
      item?.linkPdfRcta &&
      typeof item?.linkPdfRcta === "string" &&
      item.linkPdfRcta.trim() !== ""
    ) {
      const url = item.linkPdfRcta.trim();
      try {
        if (isMobile) {
          const newWindow = window.open(url, "_blank");
          if (!newWindow) {
            showToaster(
              {
                texto:
                  "Debes habilitar las ventanas emergentes en tu navegador.",
                tipo: "warning",
              },
              "centroArriba"
            )(toasterDispatch);
          }
        } else {
          showModal(
            "Genericos/PDFViewer/PDFViewer",
            {
              url: url,
              titulo: "Orden digital",
              dissmiss: () => hideModal()(modalDispatch),
            },
            [],
            "centro",
            true
          )(modalDispatch);
        }
      } catch (error) {
        showToaster(
          { texto: "Error al abrir el documento", tipo: "danger" },
          "centroArriba"
        )(toasterDispatch);
      } finally {
        setLoadingPDF(false);
      }
      return;
    }

    const onSuccess = (data) => {
      const blob = base64toBlob(data, "application/pdf");
      const blobUrl = URL.createObjectURL(blob);

      if (isMobile) {
        const newWindow = window.open("", "_blank");
        if (!newWindow) {
          showToaster(
            {
              texto: "Debes habilitar las ventanas emergentes en tu navegador.",
              tipo: "warning",
            },
            "centroArriba"
          )(toasterDispatch);
          setLoadingPDF(false);
          return;
        }
        newWindow.location.href = blobUrl;
      } else {
        // Abre visor modal en tablet/desktop
        showModal(
          "Genericos/PDFViewer/PDFViewer",
          {
            url: blobUrl,
            titulo: "Orden digital",
            dissmiss: () => hideModal()(modalDispatch),
          },
          [],
          "centro",
          true
        )(modalDispatch);
      }
      setLoadingPDF(false);
    };

    const onError = () => {
      showToaster(
        { texto: "Error al generar la orden.", tipo: "danger" },
        "centroArriba"
      )(toasterDispatch);
      setLoadingPDF(false);
    };

    if (item?.idLabProtAgenda) {
      wsGetPDFOrdenDigital(item.id, (isCorrect, data) => {
        if (isCorrect) onSuccess(data);
        else onError();
      })(labOrdenDigitalDispatch);
    } else {
      wsGetPDFOrdenEstudio(item.id, (isCorrect, data) => {
        if (isCorrect) onSuccess(data);
        else onError();
      });
    }
  };

  const verAgendasDisponibles = (item) => {
    setLoadingPDF(true);
    if (!item?.requiereTurno) {
      setFlgVolverOrdenDigitalEstudio(true)(ordenDigitalDispatch);
    }
    setAltaOrdenDigitalEstudio(item.id)(ordenDigitalDispatch);
    setMedicoSolicitante(item.idMedSolicitante)(ordenDigitalDispatch);
    wsGetGrupoByIdOrden(item.id, (isCorrect, data) =>
      nextStep(isCorrect, data, item)
    )(ordenDigitalDispatch);
  };

  const asociarTurnoLabo = (data) => {
    // setPaso("EstudiosLabo")(pasoDispatch);
    setLoadingPDF(true);
    const fecha = fechaTurnoFormat();
    const idGrupoTurnoLaboGeneral = 5;
    setFlgVolverOrdenDigitalEstudio(true)(labOrdenDigitalDispatch);
    setAltaTurnoOrdenDigital(data?.idprotocolo)(labOrdenDigitalDispatch);
    setBuscarTurnoLabo(true)(laboTurnosDispatch);
    wsGetLaboCentros((isCorrect, dataCentros) => {
      if (isCorrect) {
        wsGetLaboTurnos(
          fecha,
          -1,
          -1,
          idGrupoTurnoLaboGeneral,
          -1,
          (isCorrect, data) => nextStepTurnoLabo(isCorrect, data, dataCentros)
        )(laboTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "Error al obtener centros de laboratorio.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    })(laboGrupoDispatch);
  };

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const refreshOrdenes = () => {
    setLoading(true);
    wsGetOrdenDigitalEstudio(nextStepOrdenes)(ordenDigitalDispatch);
  };

  const nextStep = (isCorrect, data, item) => {
    if (isCorrect) {
      if (item?.requiereTurno) {
        setPaso("NumeroAfiliado")(pasoDispatch);
      } else {
        history.push("/estudios");
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de estudio.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepTurnoLabo = (isCorrect, data, dataCentros) => {
    if (isCorrect) {
      let centros = [
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .centrosLabo,
        ...dataCentros,
      ];
      if (centroQR === null || centroQR === undefined) {
        showToaster(
          {
            texto: "Error al obtener centro, vuelva a escanear el QR.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        let turnoByCentro = data.data.filter(
          (turno) => turno.idCentro.toString() === centroQR
        );
        if (turnoByCentro.length === 0) {
          showToaster(
            {
              texto: "No hay turnos disponibles para el centro seleccionado.",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        } else {
          let descEstudio = "TURNO DE LABORATORIO GENERAL";
          editaTurnosDisponibles({
            ...turnosDisponiblesState.turnosDisponibles.turnosData,
            turnos: turnoByCentro,
            grupoMedico: 5,
            particular: false,
            idEstudio: 5,
            descEstudio: descEstudio,
            descEspecialidad: null,
            fechaBusqueda: data.fechaBusqueda,
            dtoBusqueda: { idGrupo: 5 },
            volverOrigen: "LABORATORIOQR",
            proceso: "labo",
            filtrosData: {
              ...turnosDisponiblesState.turnosDisponibles.turnosData
                .filtrosData,
              centrosLabo: centros,
            },
          })(turnosDisponiblesDispatch);
          history.push("/turnosDisponibles");
          sessionStorage.removeItem("getOrdenes");
          sessionStorage.removeItem("ordenesList");
        }
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de laboratorio.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital((isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo)
      )(labOrdenDigitalDispatch);
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      sessionStorage.setItem("getOrdenes", true);
      let ordenesConcat = [...data, ...dataLabo];
      let ordenesSinAsociar = ordenesConcat.filter(
        (orden) => orden.idturno === -1 || orden.idLabProtAgenda === -1
      );
      let ordenByFecha = ordenesSinAsociar.sort((a, b) => {
        return (
          new Date(b.fechaalta).getTime() - new Date(a.fechaalta).getTime()
        );
      });
      setOrdenesList(ordenByFecha);
      setLoading(false);
      sessionStorage.setItem("ordenesList", JSON.stringify(ordenesSinAsociar));
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    if (getOrdenes === null) {
      // wsGetOrdenesDigitalesById(authState.auth.data.paciente.codigo, nextStep);
      wsGetOrdenDigitalEstudio(nextStepOrdenes)(ordenDigitalDispatch);
    } else {
      let ordenes = JSON.parse(sessionStorage.getItem("ordenesList"));
      setLoading(false);
      setOrdenesList(ordenes);
    }
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading || loadingPDF}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <ScrollArrows
        targetRef={{
          current: document?.querySelector?.("#ordenes-body-container"),
        }}
      />
      <RefreshBox>
        <button
          onClick={() => refreshOrdenes()}
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid var(--color-latex30)",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className="spin"
        >
          <FaSyncAlt size={20} color="var(--color-latex30)" />
        </button>
      </RefreshBox>
      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ÓRDENES PARA ESTUDIOS MÉDICOS"}
        subtitle={
          "Éstas son las órdenes digitales que tu médico indicó para que puedas sacar turno."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5 id="ordenes-body-container">
              {ordenesList?.length > 0 &&
                ordenesList.map((element, index) => {
                  return (
                    <CardOrden key={index}>
                      <p className="header rb18m">
                        {element?.idLabProtAgenda
                          ? "Laboratorio"
                          : element?.idgrupoestudio_desc === ""
                          ? "Estudio"
                          : camelize(element?.idgrupoestudio_desc)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Emitida el:{" "}
                          <span className="rb16m">
                            {new Date(element?.fechaalta).toLocaleDateString()}
                          </span>
                        </p>
                        <p>
                          Médico:{" "}
                          <span className="rb16m">
                            {element?.idusuarioalta_desc}
                          </span>
                        </p>
                        <div
                          className="btnOrdenPdf rb14m"
                          onClick={() => handleClickButton(element)}
                        >
                          <PdfIcon /> Ver Orden
                        </div>
                        <ButtonP5
                          onClick={
                            element?.idLabProtAgenda
                              ? () => asociarTurnoLabo(element)
                              : () => verAgendasDisponibles(element)
                          }
                        >
                          {!element?.requiereTurno
                            ? "Solicitar turno"
                            : "Atenderme ya"}
                        </ButtonP5>
                      </div>
                    </CardOrden>
                  );
                })}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OrdenesDigitales;
